import { Skeleton } from '@picsart/design-system/components/Skeleton';
import BrandsCenteredContent from 'components/BrandsCenteredContent';
import useStyles from './styles';

const GridSkeleton = () => {
  const styles = useStyles();

  const skeletonItems = Array.from({ length: 8 }, (_, index) => (
    <Skeleton key={`skeleton-item-${index}`} className={styles.skeletonItem} />
  ));

  return (
    <div data-testid="grid-skeleton">
      <BrandsCenteredContent>
        <Skeleton className={styles.skeletonTitle} />
        <div className={styles.skeletonWrapper}>{skeletonItems}</div>
      </BrandsCenteredContent>
    </div>
  );
};

export default GridSkeleton;
